import { render, staticRenderFns } from "./BoxStylingComponent.vue?vue&type=template&id=35281306&"
import script from "./BoxStylingComponent.vue?vue&type=script&lang=js&"
export * from "./BoxStylingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports